import { useStores } from 'modules/stores/hooks/use-stores'
import { Dispatch, SetStateAction } from 'react'
import { handle422Error } from 'shared/utils/parse-422-errors'
import { useStoresApi } from '../../hooks/use-stores-api'
import { StoreErrorsInterface, StoreInterface } from '../../types/stores-interface'
import { getStoreUpdateData } from '../utils/get-store-update-data'
import { useStore } from './use-store'
import { useStoreQuery } from './use-store-query'

export const useStoreEdit = ({
  setErrors,
}: {
  setErrors: Dispatch<SetStateAction<StoreErrorsInterface>>
}) => {
  const { storeId } = useStoreQuery()
  const { data: store, mutate } = useStore(storeId)
  const { mutate: mutateList } = useStores()
  const { updateStore } = useStoresApi()

  const onSave = async (data: Partial<StoreInterface>) => {
    if (!store) return
    try {
      const responseData = await updateStore(store.id, getStoreUpdateData({ ...store, ...data }))
      await mutateList(
        prev =>
          prev && {
            ...prev,
            items: prev.items.map(item => (item.id === store.id ? responseData : item)),
          },
        false,
      )

      await mutate(responseData, false)
    } catch (e) {
      handle422Error(e, setErrors)
      throw e
    }
  }

  return { onSave }
}
